export default defineAppConfig({
    appName: 'Vetzet',
    contactAddress: 'Gəncə ş., Əziz Əliyev küç. 11B',
    contactEmail: 'hsdm@vetzetcom.net',
    contactPhone: '+994 55 560 55 34',
    ui: {
        colors: {
            primary: "teal",
            neutral: "slate",
        },
    },
    icon: {
        mode: 'css',
        cssLayer: 'base'
    }
});
